import sha256 from 'crypto-js/sha256';
import api from '../api/api';
import useStore from '../store/store';

const Login = async ({ iso2, phone, password }) => {
    const {
        setAccessToken,
        setRefreshToken,
        setPhone,
        setPermissions,
        setProfile,
        setDefaultAvatars,
        setFormError,
        setLoading,
        setEmail,
    } = useStore.getState();

    setLoading(true);

    try {
        const response = await api.post('/security/login', {
            iso2,
            phone,
            password: sha256(password).toString(),
        });

        const {
            success,
            errCode,
            accessToken,
            refreshToken,
            permissions,
            profile,
            defaultAvatars,
            email,
        } = response.data;

        if (success) {
            localStorage.setItem('accessToken', accessToken);
            localStorage.setItem('refreshToken', refreshToken);
            localStorage.setItem('iso2', iso2);
            localStorage.setItem('phone', phone);

            api.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

            // Save tokens in state. This will redirect to main page.
            setAccessToken(accessToken);
            setRefreshToken(refreshToken);
            setPhone(phone);
            setPermissions(permissions);
            setProfile(profile);
            setDefaultAvatars(defaultAvatars);
            setEmail(email);
            setLoading(false);
        } else if (!success && errCode) {
            setLoading(false);
            setFormError(errCode);
        }
    } catch (e) {
        console.error(e);
        // Network Error (error code 17)
        if (e.code) setFormError(e.code);
    }
};

export default Login;
